import { render, staticRenderFns } from "./market-analysis.vue?vue&type=template&id=393d0a21&scoped=true"
import script from "./market-analysis.vue?vue&type=script&lang=js"
export * from "./market-analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d0a21",
  null
  
)

export default component.exports